import api from '../../api/moviedb';
import * as types from '../mutation-types';

const state = {
  genres: [],
  showIntro: true,
  showErrorQuery: false,
  showMovieDetails: false,
  movieDetails: null,
};

const mutations = {
  [types.SET_GENRES](state, genres) {
    state.genres = genres;
  },
  [types.DISABLE_INTRO](state) {
    state.showIntro = false;
  },
  [types.TOGGLE_ERROR_QUERY](state) {
    state.showErrorQuery = !state.showErrorQuery;
  },
  [types.TOGGLE_MOVIE_DETAIL](state) {
    state.showMovieDetails = !state.showMovieDetails;
  },
  [types.SET_MOVIE_DETAIL](state, movie) {
    state.movieDetails = movie;
  },
};

const actions = {
  getGenres: ({ commit }) => {
    api.getGenres(genres => {
      commit(types.SET_GENRES, genres);
    });
  },
  disableIntro: ({ commit }) => commit(types.DISABLE_INTRO),
  toggleMovieDetails: ({ commit }) => commit(types.TOGGLE_MOVIE_DETAIL),
  setMovieDetails: ({ commit }, movie) => commit(types.SET_MOVIE_DETAIL, movie),
};

const getters = {
  genresString(state) {
    return genres =>
      state.genres
        .filter(({ id }) => genres.includes(id))
        .map(({ name }) => name)
        .join(', ');
  },
  getStatusIntro(state) {
    return state.showIntro;
  },
  getStatusMovieDetails(state) {
    return state.showMovieDetails;
  },
  getMovieDetails(state) {
    return state.movieDetails;
  },
};

export default {
  state,
  mutations,
  actions,
  getters,
};
